import { Injectable, Injector } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';

import { StorageService } from './storage.service';
import { DeviceService } from './device.service';
import { SubdomainService } from './subdomain.service';
import { DateHandlerService } from './date-handler.service';
import { LogoutService } from './logout.service';

@Injectable({
  providedIn: 'root',
})
export class InterceptorService implements HttpInterceptor {
  constructor(
    private storageService: StorageService,
    private deviceService: DeviceService,
    private subdomainService: SubdomainService,
    private dateHandlerService: DateHandlerService,
    private injector: Injector
  ) { }

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const token = this.storageService.getAccessToken();
    const deviceId = this.deviceService.getDeviceId();
    const subdomain = this.subdomainService.getSubdomain();

    let headers = req.headers;

    headers = headers.set('timeout', '1800000');
    headers = headers.set('X-Timezone-Offset', this.getTimezoneOffset());

    if (token)
      headers = headers.set('Authorization', `Bearer ${token}`);

    if (deviceId)
      headers = headers.set('deviceId', deviceId);

    if (subdomain)
      headers = headers.set('subdomain', subdomain);

    const contentType = headers.get('Content-Type');

    if (req.body instanceof FormData) {
      headers = headers.delete('Content-Type');
    } else if (!contentType) {
      headers = headers.set('Content-Type', 'application/json');
    } else if (
      (contentType || '').toLocaleLowerCase().trim() === 'multipart/form-data'
    ) {
      // Is file uplaod request
      // Content type will be automatically set. So, removing this content type to avoid failed request
      headers = headers.delete('Content-Type');
    }

    const duplicate = req.clone({ headers: headers });

    if (duplicate.body) {
      const clone = duplicate.clone({ body: this.dateHandlerService.handleDate(duplicate.body) });
      return next.handle(clone).pipe(
        catchError((error) => {
          if (error.status === 401 || error.status === 403) {
            const logoutService = this.injector.get(LogoutService);
            const router = this.injector.get(Router);
            logoutService.performLogout();
            router.navigate(['/']);
          }
          return throwError(error);
        })
      );
    }

    return next.handle(duplicate).pipe(
      catchError((error) => {
        if (error.status === 401 || error.status === 403) {
          const logoutService = this.injector.get(LogoutService);
          const router = this.injector.get(Router);
          logoutService.performLogout();
          router.navigate(['/']);
        }
        return throwError(error);
      })
    );
  }

  private getTimezoneOffset = (): string => {
    return (String(new Date().getTimezoneOffset()));
  }
}
